import { createInjectionKey as n } from "./ghl-ui.es896.js";
const t = n("n-form"), e = n("n-form-item-insts");
export {
  t as formInjectionKey,
  e as formItemInstsInjectionKey
};
